module.exports = __webpack_public_path__ + "static/media/link-out.5181da1d.svg";